// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-iframe[data-v-c0aa2f64]{width:100%;height:100%;border:none}.video-container[data-v-c0aa2f64]{width:100%;height:100%;aspect-ratio:1.77777}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
